module.exports = __webpack_public_path__ + "img/icon-done.23d1a273.png";